const init = function () {
  const _this = this;
  // 建议为了方便使用，这里可以包装window.Alert
  window.Alert = function (msg, duration = 3000) {
    _this.$message({
      showClose: true,
      message: msg,
      type: 'error',
      duration
    })
  }

  window.Tips = function (msg, duration = 3000) {
    _this.$message({
      showClose: true,
      message: msg,
      type: 'info',
      duration
    })
  }

  window.Warning = function (msg, duration = 3000) {
    _this.$message({
      showClose: true,
      message: msg,
      type: 'warning',
      duration
    })
  }
};

export default {
  init
}



// WEBPACK FOOTER //
// ./src/services/error.js